module.exports = function () {
  /**
  * @file utils/platform,.js
  * @author gaojiexuan@baidu.com
  * @description 对外开放的三方端平台、版本相关接口；目前包装bdbox
  */
  var $ = require('../utils/_bdboxWrapper');
  /* istanbul ignore next */


  var versionCompare = require('../thirdParty/bdbox/utils/version_compare');
  /* istanbul ignore next */


  var getVersion = require('../thirdParty/bdbox/utils/getVersion');
  /* istanbul ignore next */


  var getInfoVersion = require('../thirdParty/bdbox/utils/getInfoVersion');
  /* istanbul ignore next */


  var getLiteVersion = require('../thirdParty/bdbox/utils/getLiteVersion');
  /* istanbul ignore next */


  var getProVersion = require('../thirdParty/bdbox/utils/getProVersion');
  /* istanbul ignore next */


  var getMissionVersion = require('../thirdParty/bdbox/utils/getMissionVersion');
  /* istanbul ignore next */


  var detect = require('../thirdParty/bdbox/utils/detect').apply($);

  return {
    versionCompare: versionCompare,
    isIOS: $.isIOS,
    isAndroid: $.isAndroid,
    os: $.isIOS ? 'ios' : $.isAndroid ? 'android' : 'none',
    osVersion: detect.version,
    isBox: $.isBoxApp(),
    boxType: $.isMissionBox ? 'mission' : $.isProBox ? 'pro' : $.isInfoBox ? 'info' : $.isLiteBox ? 'lite' : 'main',
    boxVersion: getMissionVersion() || getProVersion() || getInfoVersion() || getLiteVersion() || getVersion()
  };
}();